/**
 * @generated SignedSource<<7467861f75f8a605ea7a63a27a8e8d1c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EditTimelineEntryDialog_CompaniesQuery$variables = {
  search?: string | null | undefined;
};
export type EditTimelineEntryDialog_CompaniesQuery$data = {
  readonly companies: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type EditTimelineEntryDialog_CompaniesQuery = {
  response: EditTimelineEntryDialog_CompaniesQuery$data;
  variables: EditTimelineEntryDialog_CompaniesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 10
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "search"
      }
    ],
    "concreteType": "CompanyConnection",
    "kind": "LinkedField",
    "name": "companies",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditTimelineEntryDialog_CompaniesQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditTimelineEntryDialog_CompaniesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bfd0d542496119953ff309e64e2b72e1",
    "id": null,
    "metadata": {},
    "name": "EditTimelineEntryDialog_CompaniesQuery",
    "operationKind": "query",
    "text": "query EditTimelineEntryDialog_CompaniesQuery(\n  $search: String\n) {\n  companies(name: $search, first: 10) {\n    nodes {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "61422ac1f84d8526362ae2c75c1f2a8d";

export default node;
